<div *ngIf="ingredient">
  <ng-container *ngFor="let n of [].constructor(ingredient.SelectedCount); let idx = index">
    <div *ngIf="!ingredient.DealOrderMenu" class="ingredientText">
      <div>
        <span class="point">•</span>
        <span>{{ingredient.IngredientName}}</span>
      </div>
      <span *ngIf="idx >= (ingredient.SelectedCount - ingredient.PaidCount)">{{ingredient.Price}} ₪</span>
    </div>
  </ng-container>

<div *ngIf="ingredient.DealOrderMenu" class="listSet">
  <div class="header-deal-name">
     <div class="ingredientText">
    <span id="21" class="setName">{{ingredient.DealOrderMenu.Name}}</span>
     <span id="22" *ngIf="ingredient.Price > 0" class="setName">{{ingredient.Price}} ₪</span>
     </div>
    <span class="ingredientText" *ngIf="ingredient.DealOrderMenu.InviteName">#{{ingredient.DealOrderMenu.InviteName}}</span>
    <span class="ingredientText note-name" *ngIf="ingredient.DealOrderMenu.Comments">#{{ingredient.DealOrderMenu.Comments}}</span>
  </div>
  <div *ngFor="let set of ingredient.DealOrderMenu.listSets" style="width: 100%;">
    <div id="23" class="setName">{{set.SetName}}</div>
    <div *ngFor="let ing of set.Ingredients" style="width: 100%;">
      <app-ingredient-set [ingredient]="ing"></app-ingredient-set>
    </div>
  </div>
</div>

<!-- Render internal sets recursively -->
<div *ngIf="!ingredient.DealOrderMenu">
  <div *ngFor="let internalSet of ingredient.internalSets" class="listSet listSet-right">
    <span id="24" class="setName">{{internalSet.SetName}}</span>
    <div *ngFor="let ingredient2 of internalSet.Ingredients " style="width: 100%;">
      <app-ingredient-set [ingredient]="ingredient2"></app-ingredient-set>
    </div>
  </div>
</div>
</div>